import {
    GET_CATEGORIES_REQUEST,
    GET_CATEGORIES_SUCCESS,
    GET_CATEGORIES_FAILED,
    GET_CATEGORIES_FURNITURE_SUCCESS,
    GET_CATEGORIES_HOME_DECO_SUCCESS,
    GET_CATEGORIES_REAL_ESTATE_SUCCESS,
} from '../../actions/category/get-categories'

const initialState = {
    categories: [],
    requesting: false,
    error: null,
    categoriesFurniture: [],
    categoriesHomeDeco: [],
    categoriesRealEstate: [],
}

export const getCategories = (state = initialState, action) => {
    switch (action.type) {
        case GET_CATEGORIES_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                categories: [],
                error: null
            })
        case GET_CATEGORIES_FAILED:
            return Object.assign({}, state, {
                categories: [],
                requesting: false,
                error: action.error
            })
        case GET_CATEGORIES_SUCCESS:
            return Object.assign({}, state, {
                categories: action.payload.data.payload,
                requesting: false,
                error: null
            })
        case GET_CATEGORIES_FURNITURE_SUCCESS:
            return Object.assign({}, state, {
                categoriesFurniture: action.payload.data.payload,
                requestingFurniture: false,
                errorFurniture: null
            })
        case GET_CATEGORIES_HOME_DECO_SUCCESS:
            return Object.assign({}, state, {
                categoriesHomeDeco: action.payload.data.payload,
                requestingHomeDeco: false,
                errorHomeDeco: null
            })
        case GET_CATEGORIES_REAL_ESTATE_SUCCESS:
            return Object.assign({}, state, {
                categoriesRealEstate: action.payload.data.payload,
                requestingRealEstate: false,
                errorRealEstate: null
            })

        default:
            return state
    }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/category/get-categories.js